import { render, staticRenderFns } from "./HelperCenter.vue?vue&type=template&id=5c749f4a&scoped=true&"
import script from "./HelperCenter.vue?vue&type=script&lang=js&"
export * from "./HelperCenter.vue?vue&type=script&lang=js&"
import style0 from "./HelperCenter.vue?vue&type=style&index=0&id=5c749f4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c749f4a",
  null
  
)

export default component.exports